module.exports = __webpack_public_path__ + "img/icon-users-stat.beb62e2b.svg";